// extracted by mini-css-extract-plugin
module.exports = {"componentRoot":"SwiperBanner_componentRoot__I_o3I"};